import { render, staticRenderFns } from "./AddEditRequestType.vue?vue&type=template&id=55ff6773&"
import script from "./AddEditRequestType.vue?vue&type=script&lang=js&"
export * from "./AddEditRequestType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports